export const FETCH_EMPLOYMENT_TYPES = "fetchEmploymentTypes";
